import { styled } from '@mui/material/styles';
import { InputLabel } from '@mui/material';

const FormLabel = styled(InputLabel)(() => ({
    color: "black !important", // Apply color directly
    fontSize: "20px", // Increase font size
    fontFamily: 'roboto',
    '& .MuiInputLabel-asterisk': {
        color: "#ff000080"
    }
}));

export default FormLabel;
